import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { policyMakerRouteBySlug } from '../config/policyMakerNav';
import { isPolicyMakerRouteEnabled } from '../utils/policyMakerPageAccess';
import { PolicyMakerUseCaseScreenContent } from '../components/policyMaker/PolicyMakerUseCaseScreens';
import data from '../data/policy-makers-DataRequirements.json';
import { loadPolicyMakerProfile } from '../utils/policyMakerProfileStorage';

function bannerStyle(severity) {
  if (severity === 'CRITICAL') {
    return {
      wrap: 'bg-red-50 dark:bg-red-950/40 border-red-200 dark:border-red-900/50',
      text: 'text-red-800 dark:text-red-200',
      label: 'CRITICAL',
    };
  }
  if (severity === 'WARNING') {
    return {
      wrap: 'bg-amber-50 dark:bg-amber-950/40 border-amber-200 dark:border-amber-900/50',
      text: 'text-amber-900 dark:text-amber-200',
      label: 'WARNING',
    };
  }
  return {
    wrap: 'bg-gray-50 dark:bg-gray-800/80 border-gray-200 dark:border-gray-700',
    text: 'text-gray-700 dark:text-gray-300',
    label: 'ALERT',
  };
}

const PolicyMakerCommandCentre = () => {
  const { screenSlug } = useParams();
  const { user } = useAuth();
  const features = user?.subscription_plan_features || [];
  const routeMeta = policyMakerRouteBySlug(screenSlug || 'alerts');

  if (!isPolicyMakerRouteEnabled(routeMeta.id, features, user)) {
    return <Navigate to="/policy-makers/alerts" replace />;
  }

  const profile = loadPolicyMakerProfile();
  const ticker = data.meta.ticker_alert;
  const style = bannerStyle(ticker?.severity);
  const showCommandChrome = routeMeta.route === 'alerts';

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950 text-gray-900 dark:text-white">
      {showCommandChrome && ticker ? (
        <div className={`border-b-2 px-4 sm:px-6 py-2.5 flex flex-wrap items-center gap-3 ${style.wrap}`}>
          <span className="relative flex h-2 w-2 flex-shrink-0 rounded-full bg-red-500">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75" />
          </span>
          <div className={`flex-1 min-w-0 text-xs font-mono ${style.text}`}>
            <span className="font-bold">{ticker.label || style.label}</span>
            {' — '}
            {ticker.title}
            {ticker.summary ? ` · ${ticker.summary}` : ''}
            {ticker.timestamp_ago ? (
              <span className="opacity-80">
                {' '}
                · {ticker.timestamp_ago}
                {ticker.source_name ? ` · ${ticker.source_name}` : ''}
              </span>
            ) : null}
          </div>
        </div>
      ) : null}

      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
        <PolicyMakerUseCaseScreenContent routeId={routeMeta.route} profile={profile} />
      </div>
    </div>
  );
};

export default PolicyMakerCommandCentre;
